import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ACADEMIC_SEMESTERS = [
    '2025/2026 zimowy',
    '2025/2026 letni',
    '2026/2027 zimowy',
    '2026/2027 letni',
];
const FIELDS_OF_STUDY = [
    'Dietetyka I stopnia',
    'Dietetyka II stopnia',
    'Fizjoterapia',
    'Kosmetologia I stopnia',
    'Kosmetologia II stopnia',
    'Pielęgniarstwo',
    'Psychologia',
    'Zdrowie publiczne',
];
const controlStyle = {
    width: '100%',
    minHeight: 40,
    padding: '8px 10px',
    border: '1px solid #d1d5db',
    borderRadius: 8,
    background: '#fff',
    boxSizing: 'border-box',
};

function ExamTerms() {
    // helpers czasu/strefy
    const pad = (n) => String(n).padStart(2, '0');
    const formatLocal = (iso) => {
        if (!iso) return '';
        const d = new Date(iso); // interpretuje ISO (np. ...Z) i przelicza na lokalną strefę
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };
    const toLocalInputValue = (iso) => {
        if (!iso) return '';
        const d = new Date(iso);
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };
    // <input type="datetime-local"> zwraca czas lokalny bez strefy; konwertujemy go do ISO/UTC do API

    const toIsoFromLocalInput = (localVal) => {
        if (!localVal) return null;
        const [d, t] = localVal.split('T');
        const [hh, mm, ss = '00'] = t.split(':');
        return `${d} ${hh}:${mm}:${ss}`;
    };

    const { id: examId } = useParams();

    const navigate = useNavigate();
    const [terms, setTerms] = useState([]);
    const [groups, setGroups] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingTerm, setEditingTerm] = useState(null);

    const [formData, setFormData] = useState({
        group_id: '',
        exam_datetime: '',
        exam_duration: 90,
        proctoring: true,
        level:'brak'
    });

    const [newGroup, setNewGroup] = useState({
        group_name: '',
        semester: '2025/2026 letni',
        field_of_study: 'Dietetyka I stopnia',
        study_semester: 1,
        study_mode: 'stacjonarne',
    });

    const [creatingGroup, setCreatingGroup] = useState(false);

    // zegar do "żywego" blokowania +/- co 30s
    const [nowTs, setNowTs] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNowTs(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);

    const fetchTerms = () => {
        fetch(`/api/prowadzacy/egzamin/${examId}/terminy/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setTerms(data))
            .catch((err) => console.error('Błąd pobierania terminów:', err));
    };

    const fetchGroups = () => {
        fetch('/api/prowadzacy/grupy', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setGroups(data))
            .catch((err) => console.error('Błąd pobierania grup:', err));
    };

    useEffect(() => {
        if (examId) {
            fetchTerms();
            fetchGroups();
        }
    }, [examId]);

    useEffect(() => {
        if (editingTerm) {
            setFormData({
                group_id: editingTerm.group_id,
                exam_datetime: toLocalInputValue(editingTerm.exam_datetime) || '',
                exam_duration: editingTerm.exam_duration,
                proctoring: editingTerm.proctoring === 1 || editingTerm.proctoring === true,
                level: editingTerm.level || 'brak',
            });
            setShowForm(true);
        }
    }, [editingTerm]);

    const handleDelete = async (termId) => {
        if (!window.confirm('Na pewno usunąć ten termin?')) return;

        await fetch(`/api/prowadzacy/termin/${termId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        fetchTerms();
    };


    const handleAddTerm = async () => {
        const res = await fetch(`/api/prowadzacy/egzamin/${examId}/termin/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                ...formData,
                exam_datetime: toIsoFromLocalInput(formData.exam_datetime),
            }),
        });

        if (res.ok) {
            resetForm();
            fetchTerms();
        }
    };

    const handleUpdateTerm = async () => {
        const res = await fetch(`/api/prowadzacy/termin/${editingTerm.term_id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                ...formData,
                exam_datetime: toIsoFromLocalInput(formData.exam_datetime),
            }),
        });

        if (res.ok) {
            resetForm();
            fetchTerms();
        }
    };

    const resetForm = () => {
        setFormData({ group_id: '', exam_datetime: '', exam_duration: 90, proctoring: false, level: 'brak' });
        setShowForm(false);
        setEditingTerm(null);
    };

    const handleCreateGroup = async () => {
        const res = await fetch('/api/prowadzacy/grupa', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(newGroup),
        });

        if (res.ok) {
            const { group_id } = await res.json();
            fetchGroups();
            setFormData((prev) => ({ ...prev, group_id }));
            setCreatingGroup(false);
        } else {
            const err = await res.json();
            console.error('Błąd tworzenia grupy:', err);
        }
    };

    // helper: czy termin jest zablokowany (< 15 min do startu lub w przeszłości)
    const isLocked = (isoDateTime) => {
        if (!isoDateTime) return false;
        const examTs = new Date(isoDateTime).getTime();
        const threshold = nowTs + 15 * 60 * 1000; // teraz + 15 min
        return examTs <= threshold; // mniejszy lub równy => blokada
    };

    return (
        <div style={{ padding: '2rem' }}>
            <h2>Terminy egzaminu #{examId}</h2>

            <table border="1" cellPadding="10" style={{ width: '100%', marginTop: '2rem' }}>
                <thead>
                <tr>
                    <th>Grupa</th>
                    <th>Kierunek</th>
                    <th>Data i godzina</th>
                    <th>Czas trwania</th>
                    <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                {terms.map((term) => {
                    return (
                        <tr key={term.term_id}>
                            <td>{term.group_name}</td>
                            <td>{term.field_of_study}</td>
                            <td>{formatLocal(term.exam_datetime)}</td>
                            <td>{term.exam_duration} min</td>
                            <td>
                                <button  className={'but-smal'} style={{margin:'0px 10px'}} onClick={() => navigate(`/prowadzacy/termin/${term.term_id}/przebieg`)}>
                                    Przebieg
                                </button>
                                <button  className={'but-smal'} onClick={() => navigate(`/prowadzacy/termin/${term.term_id}`)}>
                                     Szczegóły
                                </button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>

            <div style={{ marginTop: '2rem' }}>
                <button
                    className="but-smal"
                    onClick={() => {
                        if (editingTerm) {
                            resetForm(); // kończy edycję i zamyka formularz
                        } else {
                            setShowForm((prev) => !prev); // tylko pokazuje/ukrywa
                        }
                        // jeżeli chowamy główny formularz, zamknij panel grupy
                        if (showForm) setCreatingGroup(false);
                    }}
                >
                    {editingTerm ? 'Anuluj edycję' : showForm ? 'Anuluj' : '+  Dodaj nowy termin'}
                </button>

                {showForm && (
                    <div
                        style={{
                            marginTop: '1rem',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 16,
                            flexWrap: 'wrap' // na wąskich ekranach kolumny się łamią jedna pod drugą
                        }}
                    >
                        {/* LEWA POŁOWA — DODAJ TERMIN (zawsze zajmuje połowę) */}
                        <div
                            style={{
                                flex: '1 1 600px',   // „połowa” na desktopie, 600px bazowo
                                minWidth: 340,
                                maxWidth: '50%',
                                border: '1px solid #ccc',
                                padding: '1rem',
                                background: '#fff',
                                borderRadius: 12
                            }}
                        >
                            <label>Grupa:</label>
                            <br />
                            <select
                                value={formData.group_id}
                                onChange={(e) => setFormData({ ...formData, group_id: e.target.value })}
                                style={{ width: '100%' }}
                            >
                                <option value="">-- wybierz --</option>
                                {groups.map((g) => (
                                    <option key={g.group_id} value={g.group_id}>
                                        {g.group_name} ({g.field_of_study})
                                    </option>
                                ))}
                            </select>

                            <button
                                className="but-smal"
                                style={{ padding: '8px 20px', margin: '10px 0' }}
                                onClick={() => setCreatingGroup(true)}
                            >
                                + Nowa grupa
                            </button>

                            <br />
                            <label>Data i godzina:</label>
                            <br />
                            <input
                                type="datetime-local"
                                value={formData.exam_datetime}
                                onChange={(e) => setFormData({ ...formData, exam_datetime: e.target.value })}
                            />
                            <br />

                            <label>Czas trwania (minuty):</label>
                            <br />
                            <input
                                type="number"
                                value={formData.exam_duration}
                                onChange={(e) => setFormData({ ...formData, exam_duration: parseInt(e.target.value) })}
                            />
                            <br />

                            <label style={{ display: 'inline-flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
                                <input
                                    type="checkbox"
                                    checked={formData.proctoring}
                                    onChange={(e) => setFormData({ ...formData, proctoring: e.target.checked })}
                                />
                                Nadzór (proctoring)
                            </label>
                            <br />
                            <br />

                            <label>Poziom bezpieczeństwa (przeglądarka SEB):</label>
                            <br />
                            <select
                                value={formData.level}
                                onChange={(e) => setFormData({ ...formData, level: e.target.value })}
                                style={{ width: '100%' }}
                            >
                                <option value={'brak'}> Brak </option>
                                <option value={'niski'}> Niski </option>
                                <option value={'umiarkowany'}> Umiarkowany </option>
                                <option value={'wysoki'}> Wysoki  </option>
                            </select>
                            <div style={{ marginTop:8, color:'#475569', fontSize:13, lineHeight:1.45 }}>
                                <div><b>Niski / umiarkowany / wysoki</b> - system wymaga pobrania SEB, specjalnej przeglądarki do przeprowadzania egzaminów z określoną czułością.</div>
                                <div style={{ marginTop:6 }}><b>Brak</b> - przeglądarka SEB (Safe Exam Browser) nie jest wymagana. Student może korzystać ze standardowej przeglądarki, a sama aplikacja zabezpiecza podejście. Po zakończonym podejściu otrzymają Państwo listę naruszeń.</div>
                            </div>



                            <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {editingTerm ? (
                                    <>
                                        <button className="but-smal" onClick={handleUpdateTerm}> Zapisz zmiany</button>
                                        <button className="but-smal" onClick={resetForm}>Anuluj edycję</button>
                                    </>
                                ) : (
                                    <button className="but-smal" onClick={handleAddTerm}> Dodaj termin</button>
                                )}
                            </div>
                        </div>

                        {/* PRAWA POŁOWA — SLOT NA GRUPĘ (stała połowa; placeholder gdy zamknięty) */}
                        <div
                            style={{
                                flex: '1 1 600px',
                                minWidth: 340,
                                maxWidth: '50%'
                            }}
                        >
                            {creatingGroup ? (
                                <div
                                    style={{
                                        border: '1px solid #888',
                                        padding: '1rem',
                                        background: '#fff',
                                        borderRadius: 12,
                                        height: '100%'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h4 style={{ margin: 0 }}>Dodaj nową grupę</h4>
                                        <button onClick={() => setCreatingGroup(false)} title="Zamknij panel grupy">
                                            ✕
                                        </button>
                                    </div>

                                    <div style={{ display: 'grid', gap: 10, marginTop: 12 }}>
                                        <input
                                            placeholder="Nazwa grupy"
                                            value={newGroup.group_name}
                                            onChange={(e) => setNewGroup({ ...newGroup, group_name: e.target.value })}
                                            style={controlStyle}
                                        />
                                        <label>
                                            Semestr:
                                            <select
                                                value={newGroup.semester}
                                                onChange={(e) => setNewGroup({ ...newGroup, semester: e.target.value })}
                                                style={controlStyle}
                                            >
                                                {ACADEMIC_SEMESTERS.map(s => <option key={s} value={s}>{s}</option>)}
                                            </select>
                                        </label>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                            <label>
                                                Kierunek:
                                                <select
                                                    value={newGroup.field_of_study}
                                                    onChange={(e) => setNewGroup({ ...newGroup, field_of_study: e.target.value })}
                                                    style={controlStyle}
                                                >
                                                    {FIELDS_OF_STUDY.map(field => <option key={field} value={field}>{field}</option>)}
                                                </select>
                                            </label>
                                            <label>
                                                Tryb:
                                                <select
                                                    value={newGroup.study_mode}
                                                    onChange={(e) => setNewGroup({ ...newGroup, study_mode: e.target.value })}
                                                    style={controlStyle}
                                                >
                                                    <option value="stacjonarne">stacjonarne</option>
                                                    <option value="niestacjonarne">niestacjonarne</option>
                                                </select>
                                            </label>
                                        </div>
                                        <label>
                                            Semestr studiów:
                                            <input
                                                type="number"
                                                value={newGroup.study_semester}
                                                onChange={(e) => setNewGroup({ ...newGroup, study_semester: e.target.value })}
                                                style={controlStyle}
                                            />
                                        </label>
                                    </div>

                                    <div style={{ marginTop: 12 }}>
                                        <button className="but-smal" onClick={handleCreateGroup}> Zapisz nową grupę</button>
                                    </div>
                                </div>
                            ) : (
                                // Placeholder utrzymujący „połowę ekranu”
                                <div
                                    style={{
                                        border: '1px dashed #cbd5e1',
                                        background: '#f8fafc',
                                        color: '#475569',
                                        borderRadius: 12,
                                        padding: '1rem',
                                        height: '100%',
                                        display: 'grid',
                                        placeItems: 'center',
                                        textAlign: 'center'
                                    }}
                                >
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 8 }}>Dodaj nową grupę</div>
                                        <div style={{ fontSize: 14, marginBottom: 12 }}>
                                            Jeżeli nie ma Twojej grupy na liście, to dodaj ją korzystając z formularza.
                                        </div>
                                        <button className="but-smal" onClick={() => setCreatingGroup(true)}>
                                            + Nowa grupa
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            </div>

            );
}

export default ExamTerms;
